import axios from "axios";
import { MessageBox, Message, Loading } from "element-ui";
import _ from "lodash";
import { getToken } from "@/utils/auth";
import router from "@/router";

const service = axios.create({
    // baseURL: "http://lx.cn/", // url = base url + request url
    // baseURL: "http://zy.628138.top/", // url = base url + request url
    baseURL: "https://exambaoming.cn/", // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 60000, // request timeout 1分钟
});

service.interceptors.request.use(
    (config) => {
        // let baseUrl = process.env.VUE_APP_BASE_API
        /*if (store.getters.token) {
            config.headers['Authorization'] = getToken()
        }*/
        config.headers["X-Token"] = "Bearer " + getToken();
        return config;
    },
    (error) => {
        // // console.log(error); // for debug
        // Message.error('请求超时!')
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.status == 200) {
            return res;
        } else if (res.status == 40000) {} else {
            Message.error(res.message);
        }

        if (res.message == "未查询到") {
            router.push({
                path: "/home",
            });
        }
    },
    (error) => {
        // // console.log(error);

        Message({
            message: error.message || "请求失败",
            type: "error",
            duration: 5 * 1000,
        });
        return Promise.reject(error);
    }
);

export default service;